import { render, staticRenderFns } from "./SwitchedSmall.vue?vue&type=template&id=23033c8d&scoped=true"
import script from "./SwitchedSmall.vue?vue&type=script&lang=js"
export * from "./SwitchedSmall.vue?vue&type=script&lang=js"
import style0 from "./SwitchedSmall.vue?vue&type=style&index=0&id=23033c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23033c8d",
  null
  
)

export default component.exports